import { Link } from "react-router-dom";
import { ArrowRightIcon } from "../../../components/design";
import {
  VITANARA_BERATUNG_DISPLAY,
  VITANARA_BERATUNG_TEL,
} from "../../../lib/contact";

// Shared end-of-page CTA — mirrors the oxblood-deep "Schenken Sie ihre Stimme"
// block on the landing page so every marketing LP closes with the same offer.
export default function ClosingCta() {
  return (
    <section
      className="paper-deep"
      style={{
        padding: "48px 22px 44px",
        position: "relative",
        marginTop: 24,
        marginLeft: "calc(50% - 50vw)",
        marginRight: "calc(50% - 50vw)",
      }}
    >
      <div style={{ maxWidth: 520, margin: "0 auto" }}>
        <div
          className="t-caps"
          style={{ marginBottom: 14, color: "rgba(244,236,216,0.5)" }}
        >
          Ein Geschenk, das bleibt
        </div>
        <h2
          style={{
            fontFamily: "var(--f-display)",
            fontWeight: 400,
            fontSize: 34,
            lineHeight: 1.05,
            letterSpacing: "-0.015em",
            margin: "0 0 16px",
            color: "var(--paper-50)",
          }}
        >
          Schenken Sie nicht{" "}
          <em style={{ color: "var(--paper-200)" }}>noch eine Tasse</em>.<br />
          Schenken Sie ihre{" "}
          <span style={{ color: "var(--ochre)", fontStyle: "italic" }}>
            Stimme
          </span>
          .
        </h2>
        <p
          style={{
            fontFamily: "var(--f-body)",
            fontSize: 16,
            lineHeight: 1.5,
            color: "rgba(244,236,216,0.75)",
            margin: "0 0 8px",
          }}
        >
          Beginnen Sie mit ein paar Fragen über die Person, die Sie
          beschenken — in fünf Minuten startklar.
        </p>
        <p
          style={{
            fontFamily: "var(--f-body)",
            fontStyle: "italic",
            fontSize: 13,
            lineHeight: 1.5,
            color: "rgba(244,236,216,0.55)",
            margin: "0 0 26px",
          }}
        >
          Alle Inhalte und Rechte bleiben bei der erzählenden Person.
        </p>
        <Link
          to="/onboarding"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            width: "100%",
            boxSizing: "border-box",
            background: "var(--paper-50)",
            color: "var(--oxblood-d)",
            fontFamily: "var(--f-ui)",
            fontWeight: 600,
            fontSize: 16,
            padding: "16px 22px",
            borderRadius: 999,
            textDecoration: "none",
            boxShadow:
              "0 2px 0 var(--paper-300), 0 10px 24px rgba(0,0,0,0.20)",
            minHeight: 50,
          }}
        >
          Jetzt verschenken
          <ArrowRightIcon />
        </Link>
        <div
          style={{
            marginTop: 16,
            fontFamily: "var(--f-script)",
            fontSize: 22,
            color: "var(--ochre)",
            textAlign: "center",
          }}
        >
          Fragen vorab? Kundenberatung:{" "}
          <a
            href={`tel:${VITANARA_BERATUNG_TEL}`}
            style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: 3 }}
          >
            {VITANARA_BERATUNG_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
